import { DocumentReferenceViewModel } from "../../model/DocumentReferenceViewModel";
import { ColumnDefinition, CustomGrid } from "../common/customGrid/CustomGrid";
import { getFileAvatarImg } from "../taskCompletion/TaskCompletionUtilities";
import TranslatedMessage from "../translations/TranslatedMessage";
import Avatar from "@material-ui/core/Avatar";
import LinearProgress from "@material-ui/core/LinearProgress";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import CloudDownload from "@material-ui/icons/CloudDownload";
import DeleteForever from "@material-ui/icons/DeleteForever";
import * as React from "react";

interface DocumentListProps extends WithStyles<typeof styles> {
  documents: DocumentReferenceViewModel[];
  onDeleteFile?: (file: DocumentReferenceViewModel) => Promise<any>;
  onDownloadFile?: (file: DocumentReferenceViewModel) => void;
}

class DocumentList extends React.PureComponent<DocumentListProps, { deletingFileId?: string }> {
  constructor(props: DocumentListProps) {
    super(props);
    this.state = {};
  }

  public render() {
    return (
      <CustomGrid<DocumentReferenceViewModel>
        columnDefinitions={this.columnsDefinitions}
        rows={this.props.documents}
        rowKey={(_) => _.id}
        addButtonTooltip=""
        onAddClick={(_) => {}}
        hideAddButton={true}
        hideSearchBar={true}
        tableProps={{ size: "small" }}
      />
    );
  }

  private columnsDefinitions: Array<ColumnDefinition<DocumentReferenceViewModel>> = [
    {
      columnKey: "icon",
      columnLabel: "",
      cellValue: (_) => <Avatar src={getFileAvatarImg(_.name)} />,
      isSortingDisabled: true,
    },
    { columnKey: "fileName", columnLabel: <TranslatedMessage id="file.name" />, cellValue: (_) => _.name },
    { columnKey: "tools", columnLabel: "", cellValue: (_) => this.getToolColumn(_), isSortingDisabled: true },
  ];

  private getToolColumn = (file: DocumentReferenceViewModel): JSX.Element => {
    const { classes } = this.props;

    return (
      <React.Fragment>
        {this.getDownloadIcon(file)}
        {this.getDeleteIcon(file)}
        {this.state.deletingFileId === file.id && <LinearProgress className={classes.deleteProgressBar} />}
      </React.Fragment>
    );
  };

  private getDownloadIcon = (file: DocumentReferenceViewModel) => {
    const { onDownloadFile } = this.props;
    if (!onDownloadFile) {
      return null;
    }
    return <CloudDownload onClick={this.handleDownloadClick(file)} className={this.props.classes.icon} />;
  };

  private handleDownloadClick = (file: DocumentReferenceViewModel) => () => {
    const { onDownloadFile } = this.props;
    if (!onDownloadFile) {
      return null;
    }

    onDownloadFile(file);
  };

  private getDeleteIcon = (file: DocumentReferenceViewModel) => {
    const { onDeleteFile } = this.props;
    if (!onDeleteFile) {
      return null;
    }
    return <DeleteForever color="error" onClick={this.handleDeleteClick(file)} className={this.props.classes.icon} />;
  };

  private handleDeleteClick = (file: DocumentReferenceViewModel) => (event: any) => {
    const { onDeleteFile } = this.props;
    if (!onDeleteFile) {
      return null;
    }
    this.setState({ deletingFileId: file.id }, () => onDeleteFile(file));
  };
}

const styles = () =>
  createStyles({
    icon: {
      cursor: "pointer",
    },
    deleteProgressBar: {
      width: "80%",
      position: "absolute",
      bottom: "0px",
      left: "10%",
    },
  });

export default withStyles(styles)(DocumentList);
